import { closeBrowser, getBrowser, getDeviceSystem } from "@/common/utils";
import React, { CSSProperties } from "react";

const backStyle: CSSProperties = {
    fontSize: '0.78rem',
    color: 'white'
}

const darkStyle:CSSProperties = {
    fontSize: '0.78rem',
    color: '#000'
}

export default class OmniHeroesBack extends React.Component<{ isDark?: boolean, type: 'home' | 'detail' | 'recommend' | 'simulator'}> {
    render() {
        return (
            <i onClick={() => this.toBack()} style={this.props?.isDark ? darkStyle : backStyle} className="iconfont icon-back"></i>
        )
    }

    toBack() {
        switch(this.props.type) {
            case 'home':
                closeBrowser()
                break
            case 'detail':
            case 'recommend':
            case 'simulator':
                const browserInfo = getBrowser()
                if (getDeviceSystem() == 'ios') {
                    window.history.back()
                }else {
                    window.alert(JSON.stringify({
                        action: 'goBack'
                    }))
                }
                
                // if (browserInfo.webview && browserInfo.webview == 'android') {
                //     window.alert(JSON.stringify({
                //         action: 'goBack'
                //     }))
                // }else {
                //     window.history.back()
                // }
                break
        }
    }
}